import { render, staticRenderFns } from "./ResponsibilityCard.vue?vue&type=template&id=07b263ae&scoped=true"
import script from "./ResponsibilityCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsibilityCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ResponsibilityCard.vue?vue&type=style&index=0&id=07b263ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b263ae",
  null
  
)

export default component.exports